/* unplugin-vue-components disabled */import script from "./QuestionContent.vue?vue&type=script&setup=true&lang=js"
export * from "./QuestionContent.vue?vue&type=script&setup=true&lang=js"

import "./QuestionContent.vue?vue&type=style&index=0&id=4f2b2986&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f2b2986"]])

export default __exports__